<div class="layout-sidebar"  (click)="app.onMenuClick()">
    <div class="layout-menu-container">
        <app-search-listing *ngIf="!app.comingFromTopBar"></app-search-listing>
        <app-menu-responsive *ngIf="app.comingFromTopBar"></app-menu-responsive>
    </div>
</div>
